import React, { ImgHTMLAttributes } from 'react';

export default function TalkTooLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
  return <img src={process.env.PUBLIC_URL + '/assets/user.png'} width={'32px'} {...props} alt={'logo'} />;
}
